import React from "react";
import { Router, Link } from "@reach/router";

export const Home = () => {
  return (
    <div className="flex flex-col min-w-full h-screen items-center justify-center">
      <div className="bg-light p-6 max-w-xl text-left">
        <h1 className="text-4xl mb-4">Toml Resume</h1>

        <p className="mb-5 ">
          Write your resume as a toml config and get back a PDF Select{" "}
          <strong>go to editor</strong> to write your resume in TOML and view
          changes or <strong>render gist</strong> to view the pdf output of a
          Github Gist containing TOML.
        </p>

        <div className="flex flex-1 ">
          <Link
            to="editor"
            className="bg-secondary text-white rounded text-xl px-2 py-1 font-bold mr-4"
          >
            Go to editor
          </Link>
          <Link
            to="gist"
            className="bg-secondary text-white rounded text-xl px-2 py-1 font-bold"
          >
            Render gist
          </Link>
        </div>
      </div>
    </div>
  );
};
